{
	"calculator": {
		"calculate-price": "Calculate ",
		"choose-service": "Choose service",
		"foreign": "international shipment prices",
		"iceland": "domestic shipment prices",
		"pdf-pricetable": "Printable price table",
		"register-shipment": "Register shipment"
	},
	"shared": {
		"choose": "Choose",
		"conformation": "Confirm",
		"customs": "Customs",
		"information": "Information",
		"max10": "Maximum length is 10 letters",
		"next-step": "Next step",
		"onlyNumbers": "Only numbers allowed",
		"optional-services": "Optional services",
		"otherPerson": "Other",
		"overview": "Overview",
		"previous-step": "Previous step",
		"receipt": "Receipt",
		"recipient": "Recipient",
		"required": "Field is required",
		"sender": "Sender",
		"shipment": "Shipment",
		"submit": "Submit",
		"type": "Type",
		"sales-push": "Register sender and recipient",
		"postbox": "Póstbox parcel locker: Register and add your payment card to <0>My account</0> before you register the shipment.",
		"postoffice": "Post Office: We recommend that you register and add your payment card in <0>My account</0> before registering the shipment. You can, however, pay for it at the post office.",
		"thenWhat": "Then what?",
		"li1": "You do not need to print a shipping label in advance. That is also possible at both the post office and the póstbox parcel locker.",
		"li2": "You do not need to know size or weight of the parcel before registering it.",
		"li3": "You can bring your parcel to the póstpox parcel locker or the post office once you have finished registering it.",
		"howToSend": "How do you want to send?",
		"success-title": "Thank you!",
		"success-message": "Your feedback has been submitted successfully.",
		"registrationQuestion": "How was the registration process?",
		"wwiii": "Flights to Israel, Iran, and Iraq have been suspended, and delays may occur for mail deliveries to nearby countries as a result."
	},
	"step-conformation": {
		"total-value": "Value",
		"country": "Country",
		"error": "Something went wrong and we didn't manage to register the shipment.",
		"no-optional-services": "No optional services",
		"number-of-parcels": "Quantity of packages in shipment",
		"overview": "Overview",
		"postbox": "Parcel locker",
		"price": "Estimated price",
		"shipment": "Shipment",
		"type": "Type of shipment",
		"who-pays": "Who pays?",
		"approve-card-charge": "I consent to my card being charged the postage fee once the package has been measured and weighed.",
		"card-charge-info": "If permission is not given for the card on file to be charged automatically, the shipment must be posted and paid for at the post office.",
		"register-card": "ATT: This shipment must be posted at the post office. If you want to post this shipment in a postbox, you must add your card details.",
		"addPaymentCard": "To post this shipment in a póstbox parcel locker, you will need to add a payment card to My account before you register your shipment.",
		"use-post-office": "To post this shipment at the post office, please click on confirm below.",
		"company-info": "Companies that use our corporate services can send shipments along with the driver who picks them up.",
		"attention-card": "Payment card missing, <0>click here to add your payment card to post in a Póstbox.</0>",
		"no-approval": "If permission is not given the shipment must be posted and paid for at the post office.",
		"post-office-option": "If you wish to post your parcel in a post office, click confirm.",
		"return-type-label": "Return type",
		"return-type-placeholder": "Select return type",
		"return-type-required": "Return type missing",
		"return-order-id-label": "Order number",
		"return-order-id-helper-text": "Enter the order number from Metta. If this was a gift then it should have included a return ticket with the order number",
		"return-order-id-placeholder": "Enter the order number",
		"return-order-id-required": "Order number missing",
		"return-order-id-positive": "Order number must be a positive number",
		"return-reason-label": "Description",
		"return-reason-swap-label": "What product would you like instead?",
		"return-reason-helper-text": "If you are swapping products you must write what you must write what product you want instead including color and size. We recommend copying the link to the new product from the Metta website and pasting it below",
		"return-reason-required": "Return reason missing",
		"return-reason-placeholder": "Any other details you want to share?",
		"return-reason-swap-placeholder": "Paste the link to the new product along with the color and size",
		"return-product-label": "What product are you returning?",
		"return-product-placeholder": "Product name here",
		"return-product-helper-text": "Write the name of the product that you're returning, you may write more than one product name. If you're returning the entire order then you can write \"All\"",
		"return-product-required": "Product name missing",
		"return-options": {
			"gift-credit": "Gift- receive store credit",
			"gift-swap": "Gift- swap to another product",
			"return-credit": "Return- receive store credit",
			"return-swap": "Return- swap to another product"
		},
		"return-cancel-button": "Go back",
		"return-cancel-button-text": "This is a registration form for returning items at Metta Sport. If you are not returning an item, choose 'Go back'"
	},
	"step-export": {
		"add-item": "Are more items in the shipment?",
		"amount-must-be-a-numer": "Amount must be a number",
		"value-greater-then-zero": "Value cannot be 0",
		"battery": "battery",
		"cant-deliver": "If delivery is not possible",
		"commercial-sample": "Commercial sample",
		"content": "Content",
		"content-placeholder": "In English, only one item per line",
		"content-example": "If a package contains, for example, three items (such as shoes, pyjamas, and a hat), you may not list all the items on a single line. You must write one item “Shoes” on the first line and then select “Add another item“ and write “pyjamas”, then add a new line for the “hat” (do not write “gift”).",
		"count-must-be-a-number": "Quantity must be a number",
		"count-greater-then-zero": "Quantity must be at least one",
		"currency": "Currency",
		"currency-choose": "Choose currency",
		"dangerous": "No hazardous items in the shipment",
		"dangerous-link": "Dangerous goods not allowed",
		"dangerous-not-allowed": "Dangerous items are not allowed",
		"destroy": "Destroy shipment",
		"documents": "Documents",
		"exampleOfDangerousGoods": "Example of dangerous goods",
		"lithiumWarning": "Please note, the country does not accept lithium batteries or lithium cells.",
		"field-required": "Field is required",
		"gift": "Gift",
		"info": "Customs information",
		"more-info": "The sender is responsible for all declared information, including the contents, value, HS code, and any other information used for customs clearance. Once the shipment has left the country of origin, this information cannot be changed.",
		"more-items": "Does the shipment contain more items?",
		"other": "other",
		"package": "Package",
		"package-choose": "Choose package",
		"perfume": "perfume",
		"product": "Product",
		"quantity": "Quantity",
		"quantityPlaceholder": "Quantity",
		"return": "Send back to me",
		"returnGoods": "Returning goods",
		"sprayCan": "spray can",
		"total-price": "Total custom price",
		"unit-price": "Unit price",
		"weight": "Weight",
		"total-weight": "Total weight",
		"weight-must-be-a-number": "Weight must be a number",
		"weight-greater-then-zero": "Weight must be greater than 0",
		"returnPolicy": "If delivery fails?",
		"chooseFromList": "Choose from list",
		"dangerousGoods": "I have read the information in the",
		"dangerousGoods2": "terms",
		"dangerousGoods3": "and conditions regarding hazardous materials and confirm that the shipment does not contain any hazardous materials.",
		"usaTerms": "I have read and accept the",
		"usaTerms2": "terms",
		"usaTerms3": "and conditions regarding shipments to the United States.",
		"messageUSA": "Note: Only letters or parcels containing documents or gifts (with a maximum value of USD100) can be declared.",
		"usaSenderInformation": "<0>NOTE: If US authorities determine that import duties must be paid on the shipment before it is delivered, or if the information about the contents is not correct, all costs will fall on the sender.</0> The sender bears full responsibility for ensuring that correct information is registered for the contents and value of the shipment to the United States in accordance with the new customs legislation of US authorities. We therefore recommend carefully reviewing the terms and conditions.",
		"terms": "Terms and conditions",
		"customsInfoHeader": "Customs information",
		"header": "Information for customs and terms",
		"chooseCountry": "Select origin country",
		"countryPlaceholder": "Country",
		"countryOfOrign": "Country of origin",
		"insert-item": "Add an item here",
		"hsCodeLookup": {
			"title": "Search for a tariff code",
			"manualTitle": "Enter a tariff code manually",
			"change": "Change",
			"namePlaceholder": "Example: Cotton shirt",
			"nameLabel": "Description in english",
			"searchLabel": "Search",
			"searchPlaceholder": "Example: Cotton shirt or 481720",
			"editHsCode": "Change tariff code",
			"hsCodeLabel": "Tariff code",
			"hsCodePlaceholder": "Example: 620520",
			"search": "Search",
			"cancel": "Cancel",
			"manualEntry": "Enter tariff code manually",
			"backToSearch": "Back to search",
			"continue": "Continue",
			"resultsTitle": "Select tariff code from the list below",
			"noResults": "No tariff codes found. Try a different search term.",
			"searchError": "Something went wrong while searching. Enter the tariff code manually, or try again.",
			"throttled": "Too many searches in a short time. Enter the tariff code manually, or wait a few minutes and try again.",
			"selectionRequired": "You must select a tariff code to continue.",
			"removeItem": "Remove item",
			"required": "Field is required",
			"hsCodeInvalid": "Tariff code must be 6 digits"
		}
	},
	"step-info": {
		"address": "Address",
		"address-cont": "Address continuation",
		"address-required": "Field is required",
		"addressed-to": "Delivers to",
		"contact": "Contact",
		"email": "Email",
		"email-format": "Wrong format",
		"email-spell-warning": "Could there be an error in the email did you mean {{email}}",
		"email-undeliverable": "Email is undelivarable or does not exist",
		"email-invalid": "Invalid email",
		"email-required": "Field is required",
		"field-required": "Field is required",
		"info": "Information",
		"max": "Too many characters",
		"name": "Name",
		"name-required": "Field is required",
		"no-icelandic-letters": "Icelandic letters are not allowed in emails",
		"phone": "Mobile phone",
		"genericPhone": "Phone number",
		"receiverPhone": "Receiver's mobile phone",
		"phone-info": "By adding the recipient's mobile number they can be notified via mobile when their parcel is ready for delivery (only applies to domestic shipments).",
		"shipment-phone-format-info": "Enter 6111111, +447911123456, or 00447911123456.",
		"phone-country-search": "Search country",
		"phone-min": "Phone is 7 digits",
		"phone-recipient-max": "Phone is max 15 digits",
		"phone-recipient-max7": "Phone is max 7 digits",
		"phone-required": "Field is required",
		"mobile-format": "The recipient's phone number must be a mobile number",
		"phone-format": "Incorrect phone format",
		"phone-international-prefix": "For non-Icelandic phone numbers, add a + or 00 prefix.",
		"phone-sender-max": "Phone number is 7 digits",
		"phone-start": "Phone number has to start with 4, 5, 6, 7 or 8",
		"place": "City/Town",
		"poscode-required": "Field is required",
		"postcode": "Zip code",
		"recipient-email-info": "Please add the email address of the shipment recipient. If you don‘t have the recipients email you can add your own instead.",
		"required-email-or-phone": "Email or phone number required",
		"sender-foreign": "Sender does not have an Icelandic social ID",
		"social-id-required": "Field is required",
		"ssn": "Social ID",
		"senderSsn": "Sender social ID",
		"ssn-min": "At least 10 digits",
		"ssn-max": "Cannot be more than 10 digits",
		"ssn-required": "Field is required",
		"ssn-valid": "Social ID is not valid",
		"tooLong": "Too many characters",
		"zip-incorrect": "Zip incorrect for selected country",
		"saveRecipient": "Save new recipient",
		"updateRecipient": "Update recipient",
		"company": "Do you want to learn about our ",
		"insuranceTerms": "I have read and agree to Iceland Post's <0>Terms & conditions</0>",
		"receiver-phone": "Recipient's phone number",
		"receiver-email": "Recipient's email address",
		"mustHaveSSNWhenUS": "You must provide ID number for shipments to the USA",
		"companySenderBusinessAccountInfo": "Companies must register shipments to EU countries on the Business Account. <0>Log in</0>",
		"requiresBusinessAccountForCompanySender": "Companies must register shipments to EU countries on the Business Account. <0>Log in</0>"
	},
	"step-optional-services": {
		"account": "Account",
		"account-required": "Field is required",
		"account-type": "Account type",
		"account-type-length": "Too many letters",
		"account-type-required": "Field is required",
		"amount": "Amount (ISK)",
		"amount-min": "Minimum amount is 500 ISK",
		"amount-max": "Maximum amount is 3.000.000 ISK",
		"amount-required": "Field is required",
		"amount-type": "Must be a number",
		"bank": "Bank",
		"bank-info-incorrect": "Bank info was not on correct format",
		"bank-required": "Field is required",
		"choose-optional-service": "Choose services",
		"min-amount": "Minimal amount is 500 ISK which makes the shipping insured for 100 thousand ISK.",
		"optional-services-total": "Services total",
		"only-numbers": "Only numbers allowed",
		"price-for-recipient": "(price 300 ISK)",
		"recipient-cant-pay": "Recipient can't pay for foreign shipments, shipments to parcel lockers or registered letters",
		"reference": "Reference number",
		"reference-length": "Too many letters",
		"reference-type": "Must be a number",
		"ssn-recipient": "Social id of account owner",
		"ssn-required": "Field is required",
		"step-optional-services": "Optional services",
		"total": "Total",
		"value": "Insert value",
		"who-pays": "Who will pay for the shipment?",
		"who-pays-required": "Field is required"
	},
	"step-receipt": {
		"print": "Print PDF",
		"register-shipment": "Register another shipment",
		"success": "Success",
		"trackingnumber": "Tracking number:",
		"text-copied": "Text copied"
	},
	"step-shipment": {
		"choose-postbox": "Choose parcel locker",
		"choose-parcelpoint": "Choose parcel point",
		"choose-weight": "Estimated weight and/or dimensions",
		"choose-weight-info": "All parcels are weighed upon delivery and therefore following prices are estimations.",
		"choose-weight-info-parcel-extended": "  Weight is rounded up to next kg.",
		"dont-know-weight": "Weight of shipment unknown",
		"dont-know-weight-info": "Only lowest possible prices shown for services",
		"heavy-option": "Heavier shipment",
		"weight-unknown-info": "Only showing lowest price per delivery method",
		"round-up-text": "Round up to the nearest kilogram for accurate pricing, e.g. if the shipment weighs 1.2 kg, select 2 kg",
		"volume-question": "Do you want to enter dimensions?",
		"volume-info": "Large shipments may cost more",
		"max-letter-weight-short": "The max weight is 2000 g",
		"enter-weight-kg": "Enter weight in kg",
		"weight-placeholder": "Select weight",
		"golfset": "Imagine the weight of a golf set",
		"no-services": "No services found for given criteria.",
		"is-heavy": "The weight of my shipment exceeds 20 kg",
		"parcel-weight": "You have to put in the weight of the package",
		"pot-of-milk": "A pot of milk is 1 kg",
		"recipient-pays": "Recipient pays",
		"recipient-pays-description": "Recipient pays for the delivery of the parcel. Social id of sender needs to be included",
		"service-option": "You have to choose a service",
		"service-option-postbox": "You have to choose a postbox",
		"service-option-parcelpoint": "You have to choose a parcel point",
		"sheep": "Sheep are on average 60-70 kg",
		"step-shipment": "Shipment",
		"choose-service": "Select delivery method",
		"postbox-unavailable": "Available for a single parcel only.",
		"recipientPaysPostbox": "Please note that if the recipient is required to pay fees, the shipment cannot be delivered to a póstbox.",
		"requires-login": "To select this option you need to <0>log in here</0> on My Pages",
		"foodWarning": "Shipping fresh food between countries is prohibited e.g. smoked meat and salmon, read more here",
		"weight": "Weight",
		"round-up-weight": "Round up to the next kilogram for a more accurate price, for example, if the package weighs 1.2 kg, enter 2 kg. The minimum weight is 1 kg.",
		"enter-weight-description": "To get a more accurate price, you can fill in the volume of the shipment.",
		"size-matters": "Size can affect the price",
		"max-letter-weight": "The max weight is 2000 g. Rate information for non-traceable letters can be found <0>here</0>."
	},
	"step-type": {
		"choose-zip-code": "Choose zip code",
		"country-required-text": "Field is required",
		"delivering-from": "Sender zip code",
		"delivering-to": "Recipient zip code",
		"number-of-parcels": "Quantity:",
		"parcel": "Parcel",
		"parcel-count-required-text": "Field is required",
		"parcel-disabled-text": "Only one parcel is allowed for international shipments",
		"register-shipment": "Register shipment",
		"registered-letter": "Letter",
		"service-required-text": "Field is required",
		"what-are-you-delivering": "Choose letter or parcel",
		"error-countries": "Couldn't fetch countries",
		"error-headings": "Something went wrong",
		"where-are-you-delivering-to": "Choose country",
		"zip-required-text": "Field is required",
		"type": "Type",
		"moreThan1": "Attention: Parcel count can only be 1 if addressed to Parcel locker",
		"useRecipient": "Load saved recipient..",
		"foreignWarning": "Delays may apply to all destination countries.",
		"countryClosed": "Unfortunately, we are unable to ship to this country at this time."
	},
	"register": "If a parcel is not pre-registered, the Post will charge a 770 kr. registration fee.",
	"whoToPay": "Payment recipient",
	"required": "Field is required",
	"explanation-logged-in-1": "If you have a payment card on file, you can post your shipment in a parcel locker (Póstbox) or at post offices where expedited drop-off is available. Otherwise you can also post and pay for the shipment at any post office.",
	"explanation-logged-in-2": "You will be led through the registration process where you will supply information on the recipient, the weight of the shipment and what kind of delivery method you prefer. In the final step you decide whether to allow the shipping fee to be deducted automatically from your card.",
	"explanation-open-web-1": "If you log into 'My account', add a payment card and choose to have it billed automatically, you can post your shipment in a parcel locker (Póstbox) or at post offices where expedited drop-off is available. Otherwise you can also post and pay for the shipment at any post office.",
	"explanation-open-web-2": "You will be led through the registration process where you will supply information on the recipient, the weight of the shipment and what kind of delivery method you prefer.",
	"barcodeInfo": "This shipment must be dropped off and paid for at the post office.",
	"barcodeInfoPaymentAuthorized": "This shipment can be dropped off at the post office or in a póstbox parcel locker and the card on file will be charged.",
	"youHaveToAccept": "Please agree the terms"
}
